import { NgModule } from "@angular/core";
import { MaterialModule } from "../../shared/material.module";
import { PrimengConfirmDialogPopupComponent } from './primeng-confirm-dialog-popup';
import { PrimengCustomDialogComponent } from "./primeng-custom-dialog";
import { PrimengDeleteConfirmDialogComponent } from "./primeng-delete-confirm-dialog/primeng-delete-confirm-dialog.component";
import { PrimengMessageConfirmDialogComponent } from './primeng-message-confirm-dialog';
import { PrimengStatusConfirmDialogComponent } from './primeng-status-confirm-dialog';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MatButtonModule, MatIconModule } from "@angular/material";
import { PopupLoaderModule } from "./popup-loader";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [PrimengStatusConfirmDialogComponent, PrimengConfirmDialogPopupComponent,
    PrimengDeleteConfirmDialogComponent, PrimengMessageConfirmDialogComponent, PrimengCustomDialogComponent,],
  imports: [
    MaterialModule, CommonModule, FormsModule, ReactiveFormsModule, ProgressSpinnerModule, MatIconModule, MatButtonModule,
    PopupLoaderModule, DragDropModule, ButtonModule
  ],
  entryComponents: [PrimengStatusConfirmDialogComponent, PrimengConfirmDialogPopupComponent,
    PrimengDeleteConfirmDialogComponent, PrimengMessageConfirmDialogComponent, PrimengCustomDialogComponent,],
})
export class PrimeNGComponentsModule { }